export default __webpack_public_path__ + "static/media/blobs-no-3.549892b8.mid";